module.exports = __webpack_public_path__ + "producr-dried fresh-grass-15.jpg?d6266aef63050cf31cbb6926d28598b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-15.jpg
// module id = 73
// module chunks = 0